import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RouterExtService {
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(public router: Router) {
    this.currentUrl = this.router.url;

    // Track the current and previous URLs
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        // Store current URL in localStorage
        localStorage.setItem('currentUrl', this.currentUrl);
      }
    });

    // Override navigateByUrl to handle skipLocationChange based on environment
    const originalNavigateByUrl = router.navigateByUrl;
    router.navigateByUrl = (url: string | UrlTree, extras: NavigationExtras = { skipLocationChange: false }): Promise<boolean> => {
      if (environment.isSkipLocation) {
        // In production, always apply skipLocationChange to hide the URL
        return originalNavigateByUrl.call(router, url, { ...extras, skipLocationChange: true }).then(() => {
          // After navigating, manually update the address bar to keep it clean
          window.history.replaceState({}, '', '/');
          return true;
        });
      } 
      else {
        // In development, allow the URL to be visible for debugging
        return originalNavigateByUrl.call(router, url, extras);
      }
    };
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }

  public getCurrentUrl(): string {
    return this.currentUrl;
  }
}
